<template>
	<v-container fluid >
		<v-layout row wrap>
			<v-radio-group row v-model="paymentType">
				<v-radio :label="$t('labels.buyers')" :value="'invoices'"></v-radio>
				<v-radio :label="$t('labels.suppliers')" :value="'suppliers'"></v-radio>
			</v-radio-group>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:excel="true"
						:headers="headers"
						:items="paymentsTable.items"
						:total="paymentsTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<template v-if="paymentType!='invoices'">
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.tour_id }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.tour_name }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.tour_start_date }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.destination }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.tour_category }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.subject }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.paid_amount_display }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.paid_date_display }}</td>
									<td @click="editClick(props.item.tour_id, false)">{{ props.item.payment_account }}</td>
								</template>
								<template v-if="paymentType=='invoices'">
									<td @click="editClick(props.item.id, false)">{{ props.item.tour_id }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.invoice_number }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.tour_name }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.tour_start_date_display }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.destination_name }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.tour_category }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.subject_name }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.payment_amount_display }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.payment_date_display }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.account_name }}</td>
								</template>
								<td>
									<template v-if="paymentType!='invoices'">
										<v-btn @click="deleteClick(props.item.id, true)" icon>
											<v-icon small>fa-trash</v-icon>
										</v-btn>
										<v-tooltip bottom>
											<v-btn @click="editClick(props.item.tour_id, true)" icon slot="activator">
												<v-icon small>fa-external-link-alt</v-icon>
											</v-btn>
											<span>{{$t('tooltips.openInNewTab')}}</span>
										</v-tooltip>
									</template>
									<template v-if="paymentType=='invoices'">
										<v-btn @click="deleteClick(props.item.id, true)" icon>
											<v-icon small>fa-trash</v-icon>
										</v-btn>
										<v-tooltip bottom>
											<v-btn @click="editClick(props.item.invoice_id, true)" icon slot="activator">
												<v-icon small>fa-external-link-alt</v-icon>
											</v-btn>
											<span>{{$t('tooltips.openInNewTab')}}</span>
										</v-tooltip>
									</template>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import DataTable from "./trinkets/DataTable";

	export default {
		name: "Payments",
		components: {DataTable},
		data: function () {
			return {
				paymentsTable: {
					items: [],
					total: 0,
					lastRequest: null
				},
				paymentType: 'invoices'
			}
		},
		watch: {
			paymentType: {
				handler: function () {
					console.log(this.paymentType);
					this.reloadData(this.paymentsTable.lastRequest);
				},
				deep: true
			},
		},
		computed: {
			headers() {
				let headers = [];
				if (this.paymentType == 'suppliers') {
					headers = [
						{text: this.$t('fields.tourId'), value: 'tour_id', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.tourName'), value: 'tour_name', type: 'string', searchable: 'hidden'},
						{
							text: this.$t('fields.tourStartDate'),
							value: 'tour_start_date',
							type: 'date_range',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.tourDestination'),
							value: 'destination_id',
							type: 'dropdown|destinations',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.tourCategory'),
							value: 'tour_category_id',
							type: 'dropdown|tour-categories',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.supplierName'),
							value: 'subject_id',
							type: 'dropdown|subjects-suppliers',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.paidAmount'),
							value: 'paid_amount',
							type: 'price_range',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.paymentDate'),
							value: 'paid_date',
							type: 'date_range',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.account'),
							value: 'payment_account_id',
							type: 'dropdown|payment-accounts',
							searchable: 'hidden'
						},
						{
							text: '',
							value: 'actions',
							type: '',
							sortable: false,
							align: "right",
							width: "170px",
							searchable: false
						}
					];
				}
				if (this.paymentType == 'invoices') {
					headers = [
						{text: this.$t('fields.tourId'), value: 'tour_id', type: 'string', searchable: false},
						{text: this.$t('fields.invoiceNumber'), value: 'invoice_number', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.tourName'), value: 'tour_name', type: 'dropdown|tours', searchable: 'hidden'},
						{
							text: this.$t('fields.tourStartDate'),
							value: 'tour_start_date',
							type: 'date_range',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.tourDestination'),
							value: 'destination_id',
							type: 'dropdown|destinations',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.tourCategory'),
							value: 'tour_category_id',
							type: 'dropdown|tour-categories',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.buyerName'),
							value: 'subject_id',
							type: 'dropdown|subjects-buyers',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.paidAmount'),
							value: 'payment_amount',
							type: 'price_range',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.paymentDate'),
							value: 'payment_date',
							type: 'date_range',
							searchable: 'hidden'
						},
						{
							text: this.$t('fields.account'),
							value: 'payment_account_id',
							type: 'dropdown|payment-accounts',
							searchable: 'hidden'
						},
						{
							text: '',
							value: 'actions',
							type: '',
							sortable: false,
							align: "right",
							width: "170px",
							searchable: false
						}
					];
				}
				return headers;
			}
		},
		methods: {
			editClick(id, newTab = false) {
				let link = '/invoices/' + id + '/edit';
				if (this.paymentType != 'invoices') {
					link = '/tours/' + id;
				}
				if (!newTab) {
					this.$router.push(link)
				} else {
					let routeData = this.$router.resolve(link);
					window.open(routeData.href, '_blank');
				}
			},
			deleteClick(id) {
				let vm = this;
				this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
					if (result) {
						vm.$APICall('delete', 'payments/' + vm.paymentType + '/' + id, {}, (data, success) => {
							if (success) {
								vm.reloadData(vm.paymentsTable.lastRequest);
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						});
					}
				});
			},
			reloadData(request) {
				this.paymentsTable.lastRequest = request;
				let vm = this;
				this.$APICall('get', 'payments/' + this.paymentType, request, (data, success) => {
					if (success) {
						vm.paymentsTable.items = data.items;
						vm.paymentsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			},
			excelExport() {
				let excelRequest = JSON.parse(JSON.stringify(this.paymentsTable.lastRequest));
				excelRequest.pagination.rowsPerPage = 999999999;
				excelRequest.pagination.page = 1;

				let vm = this;
				this.$APICall('get', 'payments/' + this.paymentType, excelRequest, (data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/payments', {items: data.items, type: vm.paymentType}, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			}
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Finance');
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.payments'), href: '/#/payments', disabled: true}
			]);
		}
	}
</script>

<style scoped>

</style>
